import _ from 'lodash';
import { getColumnDataPath } from './columnData';

function getCellValue(rowData, column, language) {
  if (!rowData) {
    throw new Error('Row has no data');
  }
  if (!column) {
    throw new Error('Column configuration not available');
  }

  // 1. Calculate cell value on column (by specifying calculateCellValue on
  // column)
  if (_.isFunction(column.calculateCellValue)) {
    return column.calculateCellValue(rowData, { column, language });
  }

  // 2. Custom CellValue
  if (column.CellValue) {
    return null;
  }

  // 3. Use dataField on column
  const dataPath = getColumnDataPath(column, language);
  return _.get(rowData, dataPath);
}

// eslint-disable-next-line import/prefer-default-export
export { getCellValue };
